export const TOPIC_ADD_CLUE_BY_NET_SCHOOL_BEGIN = 'TOPIC_ADD_CLUE_BY_NET_SCHOOL_BEGIN';
export const TOPIC_ADD_CLUE_BY_NET_SCHOOL_SUCCESS = 'TOPIC_ADD_CLUE_BY_NET_SCHOOL_SUCCESS';
export const TOPIC_ADD_CLUE_BY_NET_SCHOOL_FAILURE = 'TOPIC_ADD_CLUE_BY_NET_SCHOOL_FAILURE';
export const TOPIC_ADD_CLUE_BY_NET_SCHOOL_DISMISS_ERROR = 'TOPIC_ADD_CLUE_BY_NET_SCHOOL_DISMISS_ERROR';
export const TOPIC_GET_PHONE_CODE_IS_TRUE_BEGIN = 'TOPIC_GET_PHONE_CODE_IS_TRUE_BEGIN';
export const TOPIC_GET_PHONE_CODE_IS_TRUE_SUCCESS = 'TOPIC_GET_PHONE_CODE_IS_TRUE_SUCCESS';
export const TOPIC_GET_PHONE_CODE_IS_TRUE_FAILURE = 'TOPIC_GET_PHONE_CODE_IS_TRUE_FAILURE';
export const TOPIC_GET_PHONE_CODE_IS_TRUE_DISMISS_ERROR = 'TOPIC_GET_PHONE_CODE_IS_TRUE_DISMISS_ERROR';
export const TOPIC_COOPERATION_PHONE_BEGIN = 'TOPIC_COOPERATION_PHONE_BEGIN';
export const TOPIC_COOPERATION_PHONE_SUCCESS = 'TOPIC_COOPERATION_PHONE_SUCCESS';
export const TOPIC_COOPERATION_PHONE_FAILURE = 'TOPIC_COOPERATION_PHONE_FAILURE';
export const TOPIC_COOPERATION_PHONE_DISMISS_ERROR = 'TOPIC_COOPERATION_PHONE_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/topic/redux/constants.js